import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ContactsIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Contacts",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M22.89 17.9c-1.35 2.12-3.63 3.53-6.26 3.66h-.02a7.84 7.84 0 0 1-6.23-3.57l-.02-.03c-2.01.93-3.71 2.22-5.1 3.79v.02c-.38.4-.6.94-.6 1.53 0 .55.2 1.06.53 1.46 2.8 3.23 6.91 5.26 11.49 5.26s8.6-1.99 11.38-5.14v-.02c.38-.41.6-.95.6-1.54s-.22-1.13-.59-1.54a15.2 15.2 0 0 0-5.1-3.82l-.09-.04Zm-6.28 1.65c1.78-.1 3.32-1 4.29-2.35v-.02c1.63-2.18 2.6-4.92 2.6-7.89v-.38.02C23.5 5.1 20.4 2 16.57 2S9.64 5.1 9.64 8.93v.38c0 2.98.98 5.73 2.64 7.95l-.02-.03c1 1.37 2.57 2.26 4.36 2.33h.01Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M24 28H10c-1.65 0-3-1.35-3-3V7c0-1.65 1.35-3 3-3h14c1.65 0 3 1.35 3 3v18c0 1.65-1.35 3-3 3M10 6c-.55 0-1 .45-1 1v18c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V7c0-.55-.45-1-1-1z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M10 12H6c-.55 0-1-.45-1-1s.45-1 1-1h4c.55 0 1 .45 1 1s-.45 1-1 1M10 17H6c-.55 0-1-.45-1-1s.45-1 1-1h4c.55 0 1 .45 1 1s-.45 1-1 1M10 22H6c-.55 0-1-.45-1-1s.45-1 1-1h4c.55 0 1 .45 1 1s-.45 1-1 1M17.16 16c-1.93 0-3.5-1.57-3.5-3.5S15.23 9 17.16 9s3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5m0-5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5M20.32 22c-.36 0-.71-.2-.89-.54-.45-.86-1.32-1.39-2.27-1.39s-1.82.53-2.27 1.39c-.25.49-.86.68-1.35.42a.994.994 0 0 1-.42-1.35c.79-1.52 2.34-2.47 4.04-2.47s3.25.95 4.04 2.47c.26.49.07 1.09-.42 1.35-.15.08-.31.11-.46.11Z"
      })]
    })
  }));
};